import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';

import { openCartModal, closeModal } from '../modules/active_modal';

import ModalMiniCartItem          from './ModalMiniCartItem.jsx';

class ModalMiniCart extends Component {

  constructor(props) { // getInitialState
    super(props);
  }

  componentDidMount() {
    document.getElementById('app').addEventListener('click', this.handleDocumentClick.bind(this));
  }

  componentWillUnmount() {
    document.getElementById('app').removeEventListener('click', this.handleDocumentClick.bind(this));
  }

  handleDocumentClick(ev) {
    const boxArea = findDOMNode(this.refs.box);
    let parentIsBox = ev.target.closest('.member-cart');
    if (!ev.target.contains(boxArea) && !parentIsBox) {
      this.props.dispatch([closeModal()]);
    }
  }

  render() {
    let {computedCart, cartError, store_bundle_pricing, productMap, dispatch} = this.props;
    let oCartErrorMessaging         = cartError ? (
      <div className='errorMessage showing'>
        <p>{cartError}</p>
      </div>
      ) : '';
    let bButtonDisabled = true;
    let oCart = <h6 className="center">Your box is empty.</h6>;
    let showFS = store_bundle_pricing && computedCart.items[0] && computedCart.items.map( x => x).length > 5;

    let oCartProducts = computedCart.items.map( x => x ).map((oItem, i) => {
      if(oItem && oItem.id && productMap.get(oItem.id)) oItem.author = productMap.get(oItem.id).authors[0];
      let index = i;
      if(showFS && (i !== 0 && computedCart.items.length - 4 > i )) index = -1;
      else if(!showFS && computedCart.items.length - 5 > i) index = -1;
      return (
        <ModalMiniCartItem
          key               = {'ModalMiniCartItem' + (oItem && oItem.mmid ? oItem.mmid.toString() + i.toString() : i)}
          arrayItem         = {index}
          product           = {oItem} />
      );
    }, this);

    // Ensure we have a cart to loop through.
    if( parseInt(computedCart.items.length) > 0 ) {
      bButtonDisabled = false;
      oCart = (
          <div>
            <table className="cart-order-items">
              <thead>
                <tr className="cart-header">
                  <th className="col-first"></th>
                  <th className="col-second"></th>
                  <th className="col-third"></th>
                </tr>
              </thead>
              <tbody>
                {oCartProducts}
              </tbody>
            </table>
          </div>
      );
    }


    return (
        <div className="member-cart" ref="box">
          <div className="modal-header content-max-width">
            <div className="button-wrapper">
              <button className="btn-primary" onClick={() => dispatch(openCartModal())}>Checkout</button>
            </div>
            <div className="cart-header"><h2>Recently Added</h2></div>
          </div>
          <div className="modal-body content-max-width">
            {oCartErrorMessaging}
            <div>
              {oCart}
            </div>
          </div>
          <button className="btn-secondary" onClick={() => dispatch(closeModal())}>Continue Shopping</button>
        </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'store_bundle_pricing': state.store.bundle_pricing,
      'computedCart': state.computedCart,
      'cartError': state.cartError,
      'storeType': state.store.type,
      'productMap': state.maps.get("productMap")
    };
}

export default connect(mapStateToProps)(ModalMiniCart);



// WEBPACK FOOTER //
// ./src/components/ModalMiniCart.jsx